import axios from 'axios';

export const LOAD_SETTINGS = 'LOAD_SETTINGS';



export const loadSettings = () => {
    return (dispatch, getState) => {
        axios.get("termes/settings/all").then(res =>{
            dispatch({
                type: LOAD_SETTINGS,
                payload: res.data.termes
            });
        });
    }  
};